import PropTypes from 'prop-types';
import useComponentVisible from '../../hooks/useComponentVisible';

const ChangeLanguageMobile = ({ languagesMap, currLang, handleSwitch }) => {
	const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);

	const onShowDrawerClick = () => {
		setIsComponentVisible(!isComponentVisible);
	};

	return (
		<div ref={ref} className="change-language-mobile">
			<button
				className="btn typography typography--light"
				onClick={onShowDrawerClick}
			>
				{currLang}
			</button>
			<div
				className={`change-language-mobile__drawer ${
					isComponentVisible ? 'change-language-mobile__drawer--show' : ''
				}`}
			>
				<ul className="change-language-mobile__languages">
					{Object.keys(languagesMap)
						.filter((lng) => lng !== currLang)
						.map((lng) => (
							<li
								className="change-language-mobile__languages-language"
								key={lng}
							>
								<button
									onClick={() => handleSwitch(lng)}
									className="btn btn--transparent typography typography--black"
								>
									{languagesMap[lng]}
								</button>
							</li>
						))}
				</ul>
			</div>
		</div>
	);
};

ChangeLanguageMobile.propTypes = {
	languagesMap: PropTypes.object,
	handleSwitch: PropTypes.func,
	currLang: PropTypes.string,
	currMobLang: PropTypes.string,
};

export default ChangeLanguageMobile;
